export const extractFilename = (filepath) => {
  const list = filepath.split('\\');
  return list[list.length - 1];
};
